import {Button, Flex, Slider, Tooltip} from "antd";
import React, {CSSProperties, Fragment, useEffect} from "react";
import {Transformable} from "../../../feature/project/Shot";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faCaretUp, faRotateLeft} from "@fortawesome/free-solid-svg-icons";

export const ElementProperties = (props: {
    style: CSSProperties,
    element: Transformable | undefined,
    onScaleChanged: (value: number) => void
    onAlignmentChanged: (value: { x?: number, y?: number }) => void
    onTransformed: (element: Transformable) => void
}) => {
    const [value, setValue] = React.useState(props.element?.scale || 1)

    useEffect(() => {
        setValue(props.element?.scale || 1)
    }, [props.element])

    const iconStyle = { width: 16, height: 16}

    return (
        <Fragment>
            <Flex vertical={true} gap={2} style={props.style}>
                <Tooltip title={'Move to Front'}>
                    <Button style={{width: '100%', borderRadius: 4}} type='text'
                            icon={<FontAwesomeIcon icon={faCaretUp}/>} onClick={() => {
                        if (props.element) {
                            const element = {
                                ...props.element,
                                z: (props.element.z || 1) + 1
                            }
                            props.onTransformed(element)
                        }
                    }
                    }/>
                </Tooltip>
                <Tooltip title={'Move to Back'}>
                    <Button style={{width: '100%', borderRadius: 4}} type='text'
                            icon={<FontAwesomeIcon icon={faCaretDown}/>} onClick={() => {
                        if (props.element && (props.element.z || 0) > 0) {
                            const element = {
                                ...props.element,
                                z: (props.element.z !== undefined && props.element.z > 1) ? props.element.z - 1 : 1
                            }
                            props.onTransformed(element)
                        }
                    }}/>
                </Tooltip>
                {props.element?.type === 'Narrative' ?
                    <>
                        <Button
                            type='text'
                            icon={<img style={iconStyle} src={'/images/center_vertically.svg'}/>}
                            onClick={() => props.onAlignmentChanged({y:0.5})}
                        />
                        <Button
                            type='text'
                            icon={<img style={iconStyle} src={'/images/center_horizontally.svg'}/>}
                            onClick={() => props.onAlignmentChanged({x: 0.5})}
                        />
                        <Button
                            type='text'
                            icon={<img style={iconStyle} src={'/images/center.svg'}/>}
                            onClick={() => props.onAlignmentChanged({x: 0.5, y: 0.5})}
                        />
                        {/*<Button*/}
                        {/*    type='text'*/}
                        {/*    icon={<FontAwesomeIcon icon={faMessage} />}*/}
                        {/*    onClick={() => props.onAlignmentChanged({})}*/}
                        {/*/>*/}
                        <Tooltip title={'Reset'}>
                            <Button style={{width: '100%', borderRadius: 4}} type='text'
                                    icon={<FontAwesomeIcon icon={faRotateLeft}/>} onClick={() => {
                                if (props.element) {
                                    const element = {
                                        ...props.element,
                                        z: 0,
                                        scale: 1
                                    }
                                    props.onTransformed(element)
                                }
                            }}/>
                        </Tooltip>
                    </>
                    :
                    <>
                        <Slider
                            style={{height: '100%'}}
                            vertical={true} tooltip={{formatter: null}}
                            min={0.0}
                            max={10}
                            value={value}
                            step={0.01}
                            onChange={(value) => {
                                props.onScaleChanged(value)
                            }}
                            onChangeComplete={(value) => {
                                if (props.element) {
                                    const element = {
                                        ...props.element,
                                        scale: value
                                    }
                                    props.onTransformed(element)
                                }
                            }
                            }/>

                        <Tooltip title={'Reset'}>
                            <Button style={{width: '100%', borderRadius: 4}} type='text'
                                    icon={<FontAwesomeIcon icon={faRotateLeft}/>} onClick={() => {
                                if (props.element) {
                                    const element = {
                                        ...props.element,
                                        z: 0,
                                        scale: 1
                                    }
                                    props.onTransformed(element)
                                }
                            }}/>
                        </Tooltip>
                    </>}
            </Flex>
        </Fragment>
    )
}